import {
  addMonths,
  isSameMonth,
  lastDayOfMonth,
  startOfMonth
} from 'date-fns'

export const getExportMonths = currentMonth =>
  Array.from({ length: 14 }, (_, index) =>
    addMonths(currentMonth, 1 - index).toISOString()
  )

export const getClosedMonthExportRange = (selectedMonth, today = new Date()) => {
  const month = new Date(selectedMonth)

  return {
    start: startOfMonth(month),
    end: isSameMonth(month, today) ? today : lastDayOfMonth(month)
  }
}
